import React, { memo } from 'react';

/**
 * 初期状態表示コンポーネント
 *
 * 未検索時（hasSearched=false）に表示する。
 * 検索条件入力を促すメッセージを表示する。
 */
const EmptyState = () => (
  <div className="no-results">
    <p>検索条件を入力して検索ボタンを押してください。</p>
  </div>
);

/**
 * 検索結果なし表示コンポーネント
 *
 * 検索済みかつ件数0件（hasSearched=true かつ items.length===0）の時に表示する。
 * EmptyState と同じスタイルだが、メッセージが異なるため別コンポーネントとして定義する。
 */
export const NoResults = memo(() => (
  <div className="no-results">
    <p>該当する文書が見つかりませんでした。</p>
  </div>
));

export default memo(EmptyState);
